import Container from "Components/Container/Container";

import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { useTranslation } from "react-i18next";

import { Autoplay, Navigation } from "swiper/modules";
import { ArrowRight, ArrowLeft } from "@phosphor-icons/react";

const Partners = ({ data }) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const { t, i18n } = useTranslation();
  return (
    <div className="py-secondary lg:py-primary bg-white">
      <Container>
        <div className="flex items-center justify-between ">
          <h2 className="text-3xl md:text-4xl lg:text-5xl  titles-font">
            {t("nav_partner")}
          </h2>

          <div className="hidden lg:flex items-center gap-x-1">
            <button
              ref={prevRef}
              className="slider-arrow  z-[100] solution-prev-button flex items-center justify-center bg-black text-3xl text-white p-1 "
            >
              {i18n.language === "ar" ? <ArrowRight /> : <ArrowLeft />}
            </button>
            <button
              ref={nextRef}
              className=" slider-arrow z-[100] solution-next-button flex items-center justify-center bg-black text-3xl text-white p-1"
            >
              {i18n.language === "ar" ? <ArrowLeft /> : <ArrowRight />}
            </button>
          </div>
        </div>

        <div className="mt-14">
          <Swiper
            spaceBetween={12}
            slidesPerView={1.5}
            slidesPerGroup={1}
            navigation={{
              clickable: true,
              prevEl: prevRef.current,
              nextEl: nextRef.current,
            }}
            onBeforeInit={(swiper) => {
              swiper.params.navigation.prevEl = prevRef.current;
              swiper.params.navigation.nextEl = nextRef.current;
            }}
            breakpoints={{
              420: {
                slidesPerView: 2,
                slidesPerGroup: 2,
              },
              768: {
                slidesPerView: 3,
                slidesPerGroup: 3,
              },
              992: {
                slidesPerView: 5,
                slidesPerGroup: 5,
              },
            }}
            modules={[Autoplay, Navigation]}
            className=""
            speed={1000}
          >
            {data?.map((image, index) => (
              <SwiperSlide key={index}>
                <div className="border bg-white border-primary">
                  <img className="object-contain" src={image} alt="" />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </Container>
    </div>
  );
};

export default Partners;
